<template>
  <div>
    <div class="vx-row">
      <!-- <ul>
        <li v-for="page in pages1" :key="page.name">
          <a @click.stop="stateChange(page.name)" :class="page.active">{{
            page.name
          }}</a>
        </li>
      </ul> -->
    </div>
    <!-- Broadcaster -->
    <div class="w-full">
      <div class="inventory_tabSec">
        <vs-tabs alignment="center">
          <vs-tab :label="$t('setup.label.TemplateDefinition')">
            <div
              class="mr-2 mb-1 order-1"
              style="margin-left: auto; margin-right: auto; text-align: center"
            ></div>

            <!-- <vs-divider /> -->
            <vs-table
              @selected="handleSelected1"
              :max-items="descriptionItems[0]"
              pagination
              :data="broadcasters"
              description
              search
              :description-items="descriptionItems"
              description-title="Registries"
              description-connector="of"
              description-body="Pages"
            >
              <template slot="header">
                <div class="mr-2 mb-1 order-1">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-plus"
                    @click="$router.push('/CreateTemplate').catch(() => {})"
                    size="small"
                    >{{ $t("setup.label.CreateTemplateDefinition") }}</vs-button
                  >
                </div>
              </template>
              <template slot="thead">
                <vs-th>{{ $t("setup.label.Template_Name") }}</vs-th>
                <vs-th>{{ $t("setup.label.Delimiter") }}</vs-th>
                <vs-th>{{ $t("setup.label.Number_Of_Fields") }}</vs-th>
                <vs-th>{{ $t("setup.label.Header_Recorder_Type") }}</vs-th>
                <vs-th>{{ $t("setup.label.Event_Record_Type") }}</vs-th>

                <vs-th class="tHeadCenter">{{
                  $t("setup.label.Actions")
                }}</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr
                  :key="index"
                  :data="broadcaster"
                  v-for="(broadcaster, index) in data"
                >
                  <vs-td :data="broadcaster.templateName">{{
                    broadcaster.templateName
                  }}</vs-td>
                  <vs-td :data="broadcaster.delimiter">{{
                    broadcaster.delimiter
                  }}</vs-td>
                  <vs-td :data="broadcaster.numberOfFields">{{
                    broadcaster.numberOfFields
                  }}</vs-td>
                  <vs-td :data="broadcaster.headerecordtype">{{
                    broadcaster.headerecordtype
                  }}</vs-td>
                  <vs-td :data="broadcaster.eventrecordtype">{{
                    broadcaster.eventrecordtype
                  }}</vs-td>

                  <vs-td class="whitespace-no-wrap">
                    <div class="container_img">
                      <feather-icon
                        icon="EditIcon"
                        :title="$t('setup.label.Edit')"
                        svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                        @click.stop="EditTemplate(broadcaster.templateId)"
                        class="icon_row"
                      />
                      <feather-icon
                        icon="TrashIcon"
                        :title="$t('setup.label.Delete')"
                        svgClasses="w-5 h-5 text-danger stroke-current cursor"
                        @click.stop="
                          stateChange('Broadcaster');
                          editJobsPopup = true;
                          delId = broadcaster.templateId;
                        "
                        class="icon_row"
                      />
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-tab>
          <vs-tab :label="$t('setup.label.UOM')">
            <div
              class="mr-2 mb-1 order-1"
              style="margin-left: auto; margin-right: auto; text-align: center"
            ></div>
            <!-- <vs-divider /> -->
            <vs-table
              @selected="handleSelected"
              :max-items="descriptionItems[0]"
              pagination
              :data="channels"
              description
              search
              :description-items="descriptionItems"
              description-title="Registries"
              description-connector="of"
              description-body="Pages"
            >
              <template slot="header">
                <div class="mr-2 mb-1 order-1">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-plus"
                    @click="$router.push('/createchannel').catch(() => {})"
                    size="small"
                    >{{ $t("setup.label.CreateUOM") }}</vs-button
                  >
                </div>
              </template>
              <!-- <template slot="thead">
                <vs-th>{{ $t("table.channelname") }}</vs-th>
                <vs-th>{{ $t("label.channelcategory") }}</vs-th>
                <vs-th>{{ $t("table.channelsequence") }}</vs-th>
                <vs-th>{{ $t("table.broadcastername") }}</vs-th>
                <vs-th>{{ $t("table.ishdchannel") }}</vs-th>
                 <vs-th>{{ $t("label.contactmobile") }}</vs-th>
            <vs-th>{{ $t("label.email") }}</vs-th> -->
              <!-- <vs-th>{{ $t("label.heading.actions") }}</vs-th>
              </template> -->

              <!-- <template slot-scope="{ data }">
                <vs-tr
                  :key="index"
                  :data="channel"
                  v-for="(channel, index) in data"
                >
                  <vs-td :data="channel.channelName">{{
                    channel.channelName
                  }}</vs-td>
                  <vs-td :data="channel.channelCategory">{{
                    channel.channelCategory
                  }}</vs-td>
                  <vs-td :data="channel.channelSequence">{{
                    channel.channelSequence
                  }}</vs-td>
                  <vs-td :data="channel.broadcasterName">{{
                    channel.broadcasterName
                  }}</vs-td>
                  <vs-td :data="channel.isHdChannel">{{
                    channel.isHdChannel
                  }}</vs-td>
                  <vs-td class="whitespace-no-wrap">
                    <feather-icon
                      icon="EditIcon"
                      title="edit"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
                      @click.stop="editchannel(channel.id)"
                      class="ml-2"
                    />
                    <feather-icon
                      icon="TrashIcon"
                      title="delete"
                      svgClasses="w-5 h-5 hover:text-warning stroke-current cursor"
                      @click.stop="
                        stateChange('Channel');
                        editJobsPopup = true;
                        delId = channel.id;
                      "
                      class="ml-2"
                    />
                  </vs-td>
                </vs-tr>
              </template> -->
            </vs-table>
          </vs-tab>
          <vs-tab :label="$t('setup.label.RUM')">
            <div
              class="mr-2 mb-1 order-1"
              style="margin-left: auto; margin-right: auto; text-align: center"
            ></div>
            <!-- <vs-divider /> -->
            <vs-table
              @selected="handleSelected2"
              :max-items="descriptionItems[0]"
              pagination
              :data="products"
              description
              search
              :description-items="descriptionItems"
              description-title="Registries"
              description-connector="of"
              description-body="Pages"
            >
              <template slot="header">
                <div class="mr-2 mb-1 order-1">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-plus"
                    @click="
                      $router.push('/createproductmapping').catch(() => {})
                    "
                    size="small"
                    >{{ $t("setup.label.CreateRUM") }}</vs-button
                  >
                </div>
              </template>
              <!-- <template slot="thead">
                <vs-th>{{ $t("table.productcode") }}</vs-th>
                <vs-th>{{ $t("label.productdescription") }}</vs-th>
                <vs-th>{{ $t("table.channelname") }}</vs-th>

                <vs-th>{{ $t("label.heading.actions") }}</vs-th>
              </template> -->

              <!-- <template slot-scope="{ data }">
                <vs-tr
                  :key="index"
                  :data="product"
                  v-for="(product, index) in data"
                >
                  <vs-td :data="product.productCode">{{
                    product.productCode
                  }}</vs-td>
                  <vs-td :data="product.productDescription">{{
                    product.productDescription
                  }}</vs-td>
                  <vs-td :data="product.channelName">{{
                    product.channelName
                  }}</vs-td>

                  <vs-td class="whitespace-no-wrap">
                    <feather-icon
                      icon="EditIcon"
                      title="edit"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
                      @click.stop="editChannelMapping(product.productId)"
                      class="ml-2"
                    />
                  </vs-td>
                </vs-tr>
              </template> -->
            </vs-table>
          </vs-tab>
          <vs-tab :label="$t('setup.label.TimePeriod')">
            <div
              class="mr-2 mb-1 order-1"
              style="margin-left: auto; margin-right: auto; text-align: center"
            ></div>
            <!-- <vs-divider /> -->
            <vs-table
              @selected="handleSelected"
              :max-items="descriptionItems[0]"
              pagination
              :data="channels"
              description
              search
              :description-items="descriptionItems"
              description-title="Registries"
              description-connector="of"
              description-body="Pages"
            >
              <template slot="header">
                <div class="mr-2 mb-1 order-1">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-plus"
                    @click="$router.push('/createchannel').catch(() => {})"
                    size="small"
                    >{{ $t("setup.label.CreateTimePeriod") }}</vs-button
                  >
                </div>
              </template>
              <template slot="thead">
                <vs-th>{{ $t("setup.label.TimemodelName") }}</vs-th>
                <vs-th>{{ $t("setup.label.TimePeriodName") }}</vs-th>
                <vs-th>{{ $t("setup.label.StartYear") }}</vs-th>
                <vs-th>{{ $t("setup.label.EndYear") }}</vs-th>
                <vs-th class="tHeadCenter">{{
                  $t("setup.label.Actions")
                }}</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr
                  :key="index"
                  :data="channel"
                  v-for="(channel, index) in data"
                >
                  <vs-td :data="channel.timeModelName">{{
                    channel.timeModelName
                  }}</vs-td>
                  <vs-td :data="channel.timeperiodName">{{
                    channel.timeperiodName
                  }}</vs-td>
                  <vs-td :data="channel.startYear">{{
                    channel.startYear
                  }}</vs-td>
                  <vs-td :data="channel.endYear">{{ channel.endYear }}</vs-td>

                  <vs-td class="whitespace-no-wrap">
                    <div class="container_img">
                      <feather-icon
                        icon="EditIcon"
                        :title="$t('setup.label.Edit')"
                        svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                        @click.stop="editchannel(channel.timeperiodId)"
                        class="icon_row"
                      />
                      <feather-icon
                        icon="TrashIcon"
                        :title="$t('setup.label.Delete')"
                        svgClasses="w-5 h-5 text-danger stroke-current cursor"
                        @click.stop="
                          stateChange('Channel');
                          editJobsPopup = true;
                          delId = channel.id;
                        "
                        class="icon_row"
                      />
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-tab>
          <vs-tab :label="$t('setup.label.Usage_Rate_Plan')">
            <div
              class="mr-2 mb-1 order-1"
              style="margin-left: auto; margin-right: auto; text-align: center"
            ></div>
            <!-- <vs-divider /> -->
            <vs-table
              @selected="handleSelected2"
              :max-items="descriptionItems[0]"
              pagination
              :data="products"
              description
              search
              :description-items="descriptionItems"
              description-title="Registries"
              description-connector="of"
              description-body="Pages"
            >
              <template slot="header">
                <div class="list-heading">
                  {{ $t("setup.label.UsageRatePlan") }}
                </div>
                <div class="mr-2 mb-1 order-1">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-plus"
                    @click="$router.push('/CreateUsageRating').catch(() => {})"
                    size="small"
                    >{{ $t("setup.label.Create_Usage_Rate_Plan") }}</vs-button
                  >
                </div>
              </template>
              <template slot="thead">
                <vs-th>{{ $t("setup.label.Id") }}</vs-th>
                <vs-th>{{ $t("setup.label.PlanName") }}</vs-th>
                <vs-th>{{ $t("setup.label.ProductName") }}</vs-th>
                <vs-th>{{ $t("setup.label.ChargeCode") }}</vs-th>
                <vs-th>{{ $t("setup.label.TimeModelName") }}</vs-th>
                <vs-th>{{ $t("setup.label.RatingType") }}</vs-th>
                <vs-th>{{ $t("setup.label.RumName") }}</vs-th>
                <vs-th class="tHeadCenter">{{
                  $t("setup.label.Actions")
                }}</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr
                  :key="index"
                  :data="product"
                  v-for="(product, index) in data"
                >
                  <vs-td :data="product.id">{{ product.id }}</vs-td>
                  <vs-td :data="product.planDesc">{{ product.planDesc }}</vs-td>
                  <vs-td :data="product.productDesc">{{
                    product.productDesc
                  }}</vs-td>
                  <vs-td :data="product.chargeCode">{{
                    product.chargeCode
                  }}</vs-td>
                  <vs-td :data="product.timeModelName">{{
                    product.timeModelName
                  }}</vs-td>
                  <vs-td :data="product.ratingType">{{
                    product.ratingType
                  }}</vs-td>
                  <vs-td :data="product.rumName">{{ product.rumName }}</vs-td>

                  <vs-td class="whitespace-no-wrap">
                    <div class="container_img">
                      <feather-icon
                        icon="EditIcon"
                        :title="$t('setup.label.Edit')"
                        svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                        @click.stop="editChannelMapping(product.productId)"
                        class="ml-2 icon_row"
                      />
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
    <!--  -->
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="'Delete ' + title"
        :active.sync="editJobsPopup"
        class="popup-close small-popup"
      >
        <div class="center">
          <img src="@/assets/images/pages/delete.svg" />
          <div class="success-msg">{{$t("setup.label.Are_you_sure_you_want_to_delete_?")}}</div>
        </div>

        <div class="center">
          <span class="p-2">
            <vs-button type="border" @click="editJobsPopup = false">{{
              $t("setup.label.Cancel")
            }}</vs-button></span
          >

          <span class="p-2">
            <vs-button @click="deleteData(delId)">{{
              $t("setup.label.Confirm")
            }}</vs-button>
          </span>
        </div>
        <div style="height: 20px"></div>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";

export default {
  data() {
    return {
      title: "Broadcaster",
      searchOption: 0,
      togglebroadcaster: true,
      togglechannel: false,
      toggleproductmapping: false,
      descriptionItems: [5, 10, 15],
      editJobsPopup: false,
      delId: 0,
      broadcasterUsers: [],

      toggleTable: "",
      pages1: [
        { name: "Broadcaster", active: "active" },
        { name: "Channel", active: "inactive" },
        { name: "Product Mapping", active: "inactive" },
      ],
    };
  },

  computed: {
    // itemModels() {
    //   return this.$store.getters["ItemModel/getbroadcasterUserList"];
    // },
    ...mapState({
      broadcasters: (state) => state.usageRating.GetTemplate,
      channels: (state) => state.usageRating.GetTimePeriod,
      products: (state) => state.usageRating.GetUsageRatePlan,
    }),
  },
  methods: {
    stateChange(name) {
      let i = 0;
      this.title = name;
      if (name === "Broadcaster") {
        this.togglebroadcaster = true;
        this.togglechannel = false;
        this.toggleproductmapping = false;
        this.getbroadcasterData();
      } else if (name === "Channel") {
        this.togglebroadcaster = false;
        this.togglechannel = true;
        this.toggleproductmapping = false;
        this.getChannelData();
      } else {
        this.togglebroadcaster = false;
        this.togglechannel = false;
        this.toggleproductmapping = true;
        this.getProductMapping();
      }
      for (let temp of this.pages1) {
        if (temp.name === name) {
          this.pages1[i].active = "active";
        } else {
          this.pages1[i].active = "inactive";
        }
        i += 1;
      }
    },
    handleSelected(channel) {
      this.$router.push({ path: `/channelView/${channel.id}` });
    },
    handleSelected1(broadcaster) {
      this.$router.push({ path: `/ViewTemplate/${broadcaster.templateId}` });
    },
    handleSelected2(product) {
      this.$router.push({ path: `/viewProductMapping/${product.productId}` });
    },
    handlebroadcasterUserSelected(item) {
      this.$router.push({ path: `/viewbroadcasteruser/${item.broadcasterId}` });
    },
    async getbroadcasterData() {
      try {
        this.$store.dispatch("usageRating/setTemplateList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getChannelData() {
      try {
        this.$store.dispatch("usageRating/setTimePeriodList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getProductMapping() {
      try {
        this.$store.dispatch("usageRating/setUsageRatePlanList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    async getbroadcasterUserList() {
      try {
        const sup = await getbroadcasterUserData();
        this.broadcasterUsers = sup.data.pageItems;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    EditTemplate(id) {
      this.$router.push(`/EditTemplate/${id}`);
    },
    editchannel(id) {
      this.$router.push(`/editchannel/${id}`);
    },
    editChannelMapping(id) {
      this.$router.push(`/editproductmapping/${id}`);
    },
    async deleteData(id) {
      if (this.togglebroadcaster) {
        try {
          await this.$store.dispatch("broadcaster/deleteBroadcasterAction", id);
          this.getbroadcasterData();
          this.editJobsPopup = false;
        } catch (error) {
          throw Error(
            error.message.errors[0].defaultUserMessage ||
              `Api failed with status code: ${error.message.httpStatusCode}`
          );
        }
      }
      if (this.togglechannel) {
        try {
          await this.$store.dispatch("broadcaster/deleteChannelAction", id);
          this.getChannelData();
          this.editJobsPopup = false;
        } catch (error) {
          throw Error(
            error.message.errors[0].defaultUserMessage ||
              `Api failed with status code: ${error.message.httpStatusCode}`
          );
        }
      }
      if (this.toggleproductmapping) {
        try {
          await this.$store.dispatch(
            "broadcaster/deleteChannelMappingAction",
            id
          );
          this.getProductMapping();
          this.editJobsPopup = false;
        } catch (error) {
          throw Error(
            error.message.errors[0].defaultUserMessage ||
              `Api failed with status code: ${error.message.httpStatusCode}`
          );
        }
      }
    },
  },
  watch: {},
  mounted() {
    this.getbroadcasterData();
    this.getChannelData();
    this.getProductMapping();
  },
};
</script>
<style scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;

  overflow: hidden;
  background-color: rgba(var(--vs-primary), 1) !important;
  border-radius: 0.2rem;
}

li {
  float: left;
  font-weight: 550;
  font-size: 0.8rem;
  cursor: pointer;
}

li a {
  display: block;
  color: #fff;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  border: solid 0.2rem rgba(var(--vs-primary), 1);
}

li a:hover:not(.active) {
  border: solid 0.2rem rgba(var(--vs-primary), 1) !important ;
  background-color: #fff;
  color: rgba(var(--vs-primary), 1);
  box-shadow: rgba(var(--vs-primary), 1) 0px 7px 29px 0px;
}

.active {
  background-color: #fff;
  color: #333;
  border: solid 0.2rem #fff;
}
.trsnVx {
  position: absolute;
}
.slide-fade-leave-active,
.slide-fade-enter-active {
  transition: all 0.4s ease-out;
}

.slide-fade-enter-from {
  transform: translateX(-20px);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translateX(+20px);
  opacity: 0;
}
.inventory_tabSec >>> .con-vs-tabs .con-ul-tabs {
  width: 52%;
  margin: 0 auto;
  border: 1px solid #c5d0df;
  border-radius: 6px;
  position: absolute;
  left: 1rem;
  top: 1.5rem;
}
.inventory_tabSec >>> .vs-tabs-primary .con-ul-tabs .line-vs-tabs {
  background: linear-gradient(
    118deg,
    rgba(var(--vs-primary), 1),
    rgba(var(--vs-primary), 0.7)
  ) !important;
  box-shadow: none !important;
}
.inventory_tabSec >>> .vs-tabs-primary .con-ul-tabs .activeChild button {
  color: #fff !important;
}
.inventory_tabSec >>> .activeChild button.vs-tabs--btn {
  background: linear-gradient(
    118deg,
    rgba(var(--vs-primary), 1),
    rgba(var(--vs-primary), 0.7)
  );
  padding-top: 10px;
  padding-bottom: 10px;
}
.inventory_tabSec >>> .vs-tabs--ul {
  padding-top: 0;
}
.inventory_tabSec >>> .vs-tabs-position-top .vs-tabs--ul {
  /* display: inline-block; */
  width: 100%;
}
.inventory_tabSec >>> .vs-tabs--li {
  display: inline-block !important;
  width: 33.33% !important;
}
.inventory_tabSec >>> .vs-tabs--li button.vs-tabs--btn span {
  text-transform: uppercase;
  margin-left: -12px;
}
.product-order-status.vs-chip-success {
  background: #d5ebdb !important;
  border: 1px solid #34a853;
  color: #34a853 !important;
}
.product-order-status.vs-chip-orange {
  background: #fffae7 !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.view_editTable_btn {
  background: transparent;
  cursor: pointer;
}
</style>
